/**
 * Formt Sekunden zu "2 Std. 15 Min." -- fuer die SLA-Anzeige (F4-08).
 *
 * In einer eigenen Datei, weil `SlaBadge.tsx` sonst neben der Komponente eine
 * Funktion ausfuehrte -- und das schaltet das schnelle Neuladen im
 * Entwicklungsbetrieb ab.
 *
 * Ohne Sekunden: Eine Frist auf die Sekunde genau anzuzeigen taeuschte eine
 * Genauigkeit vor, die der Waechter im Minutentakt gar nicht hat. Ab einem
 * Tag verschwinden auch die Minuten -- "3 Tage 4 Std." ist genug.
 */

import type { TFunction } from 'i18next';

export function formatDuration(seconds: number, t: TFunction) {
  const total = Math.max(0, Math.round(seconds / 60));
  const days = Math.floor(total / (60 * 24));
  const hours = Math.floor((total % (60 * 24)) / 60);
  const minutes = total % 60;

  if (days > 0) return t('sla.durationDays', { days, hours });
  if (hours > 0) return t('sla.durationHours', { hours, minutes });
  return t('sla.durationMinutes', { minutes });
}
